<script>
import DynamicProduct from './DynamicProduct.vue';
import useWebsiteTexts from '@/composables/useWebsiteTexts';

export default {
  components: {
    DynamicProduct
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
    products: {
      type: Array,
      required: true,
    },
    marginTop: {
      type: String,
      default: '0px',
    },
    marginBottom: {
      type: String,
      default: '0px',
    },
  },
  data: () => {
    
    const { websiteText } = useWebsiteTexts();

    return {
      forceComputeScroll: 0,
      scrollRefreshCounter: 0,
      websiteText,
    };
  },
  computed: {
    canScrollRight() {
      if (this.forceComputeScroll < 0 || this.products.length == 0) {
        return false;
      }

      return this.$refs.container && this.$refs.container.scrollLeft + 10 < this.$refs.container.scrollWidth - this.$refs.container.clientWidth;
    },
    canScrollLeft() {
      if (this.forceComputeScroll < 0 || this.products.length == 0) {
        return false;
      }

      return this.$refs.container && this.$refs.container.scrollLeft > 0;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.refreshScrollableState();
    });
  },
  methods: {
    refreshScrollableState() {
      this.forceComputeScroll = this.forceComputeScroll == 0 ? 1 : 0;

      if (this.scrollRefreshCounter > 5) {
        return;
      }

      if (this.products.length != 0 && this.$refs.container && this.$refs.container.scrollWidth == this.$refs.container.clientWidth) {
        this.$nextTick(() => {
          this.scrollRefreshCounter += 1;
          this.refreshScrollableState();
        });
      }
    },
    getScrollIncrement() {
      return (this.$refs.container.scrollWidth / this.products.length)
        + parseFloat(getComputedStyle(document.documentElement).fontSize);
    },
    goPrev() {
      if (!this.canScrollLeft) {
        return;
      }

      this.$refs.container.scrollLeft -= this.getScrollIncrement();
    },
    goNext() {
      if (!this.canScrollRight) {
        return;
      }

      this.$refs.container.scrollLeft += this.getScrollIncrement();
    }
  }
};
</script>

<template>
  <div class="_layout-maxWidth" :style="{ marginTop: marginTop, marginBottom: marginBottom }">
    <div class="dynamic-products">
      <div class="dynamic-products_title-wrapper">
        <div class="dynamic-products_title">{{ title }}</div>
        <div v-html="text" class="dynamic-products_text"></div>
      </div>
      <div class="dynamic-products_list-wrapper">
        <div class="dynamic-products_list" ref="container" @scroll="refreshScrollableState">
          <DynamicProduct v-for="product in products" :key="product.url" :product="product" />
        </div>

        <div class="dynamic-products_navigation">
          <button
            v-if="canScrollLeft"
            class="dynamic-products_navigation-prev"
            @click.prevent="goPrev"
            :aria-label="websiteText('global__previous').value"
          ></button>
          <button
            v-if="canScrollRight"
            class="dynamic-products_navigation-next"
            @click.prevent="goNext"
            :aria-label="websiteText('global__next').value"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.dynamic-products {
  display: flex;
  flex-direction: column;
}

.dynamic-products_title {
  font-family: var(--font-header);
  font-size: 27px;
  margin-bottom: 8px;
}

.dynamic-products_list {
  display: flex;
  flex-direction: row;
  scroll-snap-type: x mandatory;
  scroll-padding: 0 2rem;
  overflow-x: scroll;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  margin: 0.5rem -1rem;
  padding: 0 0.5rem;
}

.dynamic-products_list::-webkit-scrollbar {
  display: none;
}

.dynamic-products_navigation {
  display: block;
  position: relative;
  height: 24px;
}

.dynamic-products_navigation-prev {
  background-image: url(../static/icons/left-arrow.svg);
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;
  display: inline-block;
  background-color: var(--color-white);
  border: 0;
  padding: 0;

}

.dynamic-products_navigation-next {
  background-image: url(../static/icons/right-arrow.svg);
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;
  float: right;
  background-color: var(--color-white);
  border: 0;
  padding: 0;
}

@media (--tabletAndDesktop) {
  .dynamic-products {
    flex-direction: row;
    margin: auto;
  }

  .dynamic-products_title-wrapper {
    display: block;
    width: 33.33%;
    margin-top: 1rem;
    padding-right: 1rem;
  }

  .dynamic-products_list-wrapper {
    width: 66.66%;
  }

  .dynamic-products_list {
    scroll-padding: 0;
    margin: 0.5rem -0.5rem;
    padding: 0;
  }
}
</style>
